import { StringOrArray, Subtree } from '@finder/ui-blocks.commons';

export interface Heading {
  name: string;
  link: string;
}
/**
 *  Regex to match heading tags valid versions would be:
 *  <h2 id="someid">some content </h2>
 *  <h2 class="some class" id="someid" >some content </h2>
 *  <h3 class="some class" id="someid" >some content </h3>
 *  <h2 id="blah"> <strong>Some text</strong> with <em>text</em> </h2>
 *  It will NOT match headings without an id.
 *  It will NOT match any content outside the heading.
 */
const headingRegex = /<h(?:2|3).*id="(.*?)".*>(.*?)<\/h(?:2|3)>/;

export const containsTableOfContentsBlock = async (
  body: Record<string, unknown>
): Promise<boolean> => {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    const bfj = await import('bfj' /* webpackChunkName: "bfj" */);
    const data = await bfj.stringify(body);
    return data.includes('finder/table-of-contents');
  }
  return JSON.stringify(body).includes('finder/table-of-contents');
};

/**
 * Filters out all the heading blocks by recursively walking
 * through the tree.
 * @param {Subtree}  blocks
 * @returns Only heading blocks from the tree.
 */
export const filterHeadings = (blocks: StringOrArray<Subtree[] | string>): Heading[] => {
  let filtered: Heading[] = [];

  if (!blocks || typeof blocks[0] === 'string') {
    return filtered;
  }

  (blocks as Subtree[]).forEach((subtree) => {
    const nestedSubtree = subtree.subtree;
    if (
      subtree.value &&
      subtree.value.name === 'core/heading' &&
      nestedSubtree &&
      typeof nestedSubtree[0] === 'string'
    ) {
      const id = ((nestedSubtree[0] as unknown) as string).match(new RegExp(headingRegex));

      if (id) {
        filtered.push({
          link: id[1],
          name: id[2],
        });
      }
    } else {
      filtered = [...filtered, ...filterHeadings(subtree.subtree as Subtree[])];
    }
  });

  return filtered;
};
